import { render } from "./Loading.vue?vue&type=template&id=218cfcba"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "218cfcba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('218cfcba', __exports__)) {
    api.reload('218cfcba', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=218cfcba", () => {
    api.rerender('218cfcba', render)
  })

}


export default __exports__